import { buildPaginatedListStore } from "./utils/storeBuilders";

export const useContractListStore = buildPaginatedListStore("contractList", "/contracts/", "Aucun contrat trouvé", true);
